var acc = document.getElementsByClassName("c-faq__question");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("is-active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

/*----------  IntersectionObserver  ----------*/

$(window).on("load", function() {
    const target = document.querySelectorAll(".js-io");
    const targetArray = Array.prototype.slice.call(target);
    const options = {
        root: null,
        rootMargin: "0% 0% -10% 0%",
        threshold: 0,
    };
    const observer = new IntersectionObserver(callback, options);
    targetArray.forEach((tgt) => {
        observer.observe(tgt);
    });

    function callback(entries) {
        entries.forEach(function(entry, i) {
            const target = entry.target;

            if (entry.isIntersecting && !target.classList.contains("_show")) {
                const delay = i * 100;
                setTimeout(function() {
                    target.classList.add("_show");
                }, delay);
            }
        });
    }
});